module.exports = __webpack_public_path__ + "static/media/1005361.33e19b07.jpg";